var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1357 6.64482C14.5594 6.64484 14.9305 6.98885 14.9307 7.43974V8.61259H17.0156C17.561 8.61259 17.9785 9.03104 17.9785 9.57646V16.3919C17.9785 16.9133 17.537 17.3548 17.0156 17.3548H6.9834C6.46211 17.3546 6.02051 16.9132 6.02051 16.3919V9.57646C6.02051 9.05514 6.46211 8.61277 6.9834 8.61259H9.06836V7.43974C9.06851 7.0162 9.41255 6.64505 9.86328 6.64482H14.1357ZM6.9834 9.36259C6.85699 9.36273 6.77051 9.44998 6.77051 9.57646V16.3919C6.77051 16.5184 6.85699 16.6046 6.9834 16.6048H17.0156C17.1422 16.6048 17.2285 16.5185 17.2285 16.3919V9.57646C17.2285 9.44988 17.1422 9.36259 17.0156 9.36259H6.9834ZM9.83008 7.40556C9.82506 7.41058 9.81842 7.42096 9.81836 7.43974V8.61259H14.2051V7.43974C14.205 7.42096 14.1984 7.41058 14.1934 7.40556C14.1882 7.40065 14.1783 7.39491 14.1602 7.39482H9.86328C9.8451 7.39491 9.83521 7.40065 9.83008 7.40556Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.3752f023d8e6f7c8765920ed14806f0b.svg";
export { ForwardRef as ReactComponent };